const colors = [
        '#E57373',
        '#F06292',
        '#BA68C8',
        '#9575CD',
        '#7986CB',
        '#64B5F6',
        '#4FC3F7',
        '#4DD0E1',
        '#4DB6AC',
        '#81C784',
        '#AED581',
        '#DCE775',
        '#FFF176',
        '#FFD54F',
        '#FFB74D',
        '#FF8A65',
        '#A1887F',
        '#E0E0E0',
        '#90A4AE',
        '#78909C',
    ]
;

export function getColor(index) {
    return colors[index];
}